import {
  Box,
  Divider,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { FechaField } from '../../../accesos/components/FechaField';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveRecibosAction } from '../RecibosAction';
import TablaConceptosRecibosComponent from './TablaConceptosRecibos';
import TablaMatriculasRecibosComponent from './TablaMatriculasRecibos';

const FormRecibos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const recibosStore = Redux.useSelector((state) => state.recibos);
  const matriculasStore = Redux.useSelector((state) => state.matriculas);
  const conceptosStore = Redux.useSelector((state) => state.conceptos);

  const activo = recibosStore.activo;

  const initData = {
    fechaTope: dateformat(null, {}),
    desc: null,
    total: '',
    idEstatus: 3,
    todos: false,
    idsConceptosPago: [],
    idsSecciones: [],
    idsMatriculas: [],
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    fechaTope: false,
    total: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [selectIdsConceptos, setSelectIdsConceptos] = React.useState([]);
  const [selectsMatriculas, setSelectsMatriculas] = React.useState([]);

  // React.useEffect(() => {

  //     setDataRequired({
  //       fechaTope: false,
  //       total: false,
  //     });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data.estatus]);

  React.useEffect(() => {
    let t = 0;
    selectIdsConceptos.forEach((el) => {
      const d = conceptosStore.all.find((as) => as.id === el);
      t = t + Number(d.costo);
    });
    _handleSetDataField(CONST.total.name, t.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectIdsConceptos]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (entidadesStore.activo === undefined || entidadesStore.activo === null) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (selectIdsConceptos.length === 0) {
      notify('Debes agregar al menos un concepto al recibo', { warning: true });
      return;
    }
    if (selectsMatriculas.length === 0 && !data.todos) {
      notify('Falta seleccionar para quién va el recibo', {
        warning: true,
      });
      return;
    }

    let idsMatriculas = [];
    if (selectsMatriculas.length > 0) {
      selectsMatriculas.forEach((el) => {
        const titular = el.estudiante.usuario.familiares.find((e) => e.titular);
        if (titular) {
          idsMatriculas.push({
            idMatricula: el.id,
            idFamiliar: titular.familiar.id,
          });
        }
      });
    }

    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveRecibosAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
          idsConceptosPago: selectIdsConceptos,
          idsMatriculas,
        },
        recibosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  const conceptos = (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget isLoading={conceptosStore.loadingAll} />
        <TablaConceptosRecibosComponent
          setSelectIdsConceptos={(values) => setSelectIdsConceptos(values)}
        />
      </Grid>
      <Grid item md={12}>
        <Divider />
        <Grid container spacing={1}>
          <Grid item md={6}>
            <Typography variant="h6">Monto total</Typography>
          </Grid>
          <Grid item md={3}>
            <Typography variant="h6">$ {data.total}</Typography>
          </Grid>
          <Grid item md={2}></Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  const form = (
    <>
      <Grid item xs={12} md={12}>
        <FechaField
          notDate
          views={['day']}
          openTo="day"
          botonCurrentDate={false}
          label={CONST.fechaTope.label}
          value={data.fechaTope}
          error={dataError.fechaTope}
          onChange={(e) =>
            _handleSetDataField(CONST.fechaTope.name, dateformat(e, {}))
          }
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField
          fullWidth
          size="small"
          id={CONST.desc.name}
          label={CONST.desc.label}
          value={data.desc}
          multiline
          rows={3}
          onChange={(e) => {
            if (e.target.value.length <= 100) {
              _handleSetDataField(CONST.desc.name, e.target.value);
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <EstatusField
          value={data.idEstatus}
          onChange={(e) =>
            _handleSetDataField(CONST.estatus.idName, e.target.value)
          }
          required
          error={dataError.estatus}
          allowIds={[3, 8]}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        {conceptos}
      </Grid>
      <Grid item xs={12} md={12}>
        <Stack alignItems="center" spacing={1}>
          <BotonComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            green
            saveIcon
          />
        </Stack>
      </Grid>
    </>
  );

  const matriculas = (
    <TablaMatriculasRecibosComponent
      selectsMatriculas={selectsMatriculas}
      onAll={(select) => {
        if (select) {
          setSelectsMatriculas([]);
          return;
        }
        let list = selectsMatriculas;
        matriculasStore.all.forEach((el) => {
          if (!selectsMatriculas.includes(el)) {
            const titular = el.familiares.find((e) => e.titular);
            if (titular) list.push(el);
          }
        });
        setSelectsMatriculas(list);
      }}
      onClick={(item) => {
        const exist = selectsMatriculas.some((e) => e.id === item.id);
        if (exist) {
          const l = selectsMatriculas.filter((e) => e.id !== item.id);
          setSelectsMatriculas(l);
        } else {
          setSelectsMatriculas((old) => [...old, item]);
        }
      }}
    />
  );

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            {form}
          </Grid>
        </Grid>
        <Grid item xs={12} md={8}>
          <Grid container spacing={1}>
            <Grid item md={12}>
              {matriculas}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormRecibos;
